var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ModalFullScreen", {
        attrs: {
          title: _vm.modalTitle,
          showCustomTitle: _vm.isEdittingLocked,
          static: true,
          withBgClickEvent: true,
        },
        on: { close: _vm.closeModal },
        scopedSlots: _vm._u(
          [
            {
              key: "titleLine",
              fn: function () {
                return [_vm._t("customHeader", null, { title: _vm.modalTitle })]
              },
              proxy: true,
            },
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-between bg-white pr-4 sm:pr-6 pb-3 pl-0",
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-lg leading-6 font-medium text-gray-900",
                        },
                        [_vm._v(" " + _vm._s(_vm.modalTitle) + " ")]
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "cursor-pointer flex items-center justify-center absolute top-3 right-3.5",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                        mouseover: function ($event) {
                          _vm.isHovered = true
                        },
                        mouseout: function ($event) {
                          _vm.isHovered = false
                        },
                      },
                    },
                    [
                      !_vm.isHovered
                        ? _c("CrossIcon", { staticClass: "h-4 w-4" })
                        : _vm._e(),
                      _vm.isHovered
                        ? _c("CrossIconHover", { staticClass: "h-4 w-4" })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "form",
                    [
                      _c("ValidationObserver", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ invalid, handleSubmit }) {
                              return [
                                _c(
                                  "ModalContent",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        !_vm.show
                                          ? {
                                              key: "actions",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-row gap-2 ml-auto",
                                                    },
                                                    [
                                                      _c("UiButton", {
                                                        attrs: {
                                                          variant: "outline",
                                                          size: "lg",
                                                          buttonText: "Cancel",
                                                          processing:
                                                            _vm.processing,
                                                        },
                                                        on: {
                                                          click: _vm.closeModal,
                                                        },
                                                      }),
                                                      _c("UiButton", {
                                                        staticClass:
                                                          "customButton",
                                                        attrs: {
                                                          id: "savebutton2",
                                                          disabled:
                                                            invalid ||
                                                            _vm.isEdittingLocked,
                                                          variant: "black",
                                                          size: "lg",
                                                          buttonText: "Save",
                                                          processing:
                                                            _vm.processing,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return handleSubmit(
                                                              _vm.onUpdate
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-col" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "row-span-full" },
                                          [
                                            _c(
                                              "FormGroup",
                                              { attrs: { title: "Type" } },
                                              [
                                                _c("TagMultiselect", {
                                                  staticClass: "mb-5",
                                                  attrs: {
                                                    selectedTagId:
                                                      _vm.selectedTagNewValue,
                                                    max: 10,
                                                    getcontainerStyle:
                                                      "customWidthInput",
                                                  },
                                                  on: {
                                                    input:
                                                      _vm.selectedTagNewValueFunc,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "row-span-full" },
                                          [
                                            _c(
                                              "FormGroup",
                                              {
                                                attrs: {
                                                  title: "Source",
                                                  inputClass: "fullwidthInput",
                                                },
                                              },
                                              [
                                                _c("SourcesMultiselect", {
                                                  staticClass: "mb-5",
                                                  attrs: {
                                                    getcontainerStyle:
                                                      "customWidthInput",
                                                    selectedSourceId:
                                                      _vm.selectedappliedSourceNewValue,
                                                  },
                                                  on: {
                                                    input:
                                                      _vm.selectedappliedSourceNewValueFunc,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "row-span-full" },
                                          [
                                            _c(
                                              "ValidationProvider",
                                              {
                                                attrs: { name: "Profile link" },
                                              },
                                              [
                                                _c("FormGroup", {
                                                  attrs: {
                                                    title: "Profile Link",
                                                    name: "profileLink",
                                                    placeholder:
                                                      "Link to profile on sourcing platform",
                                                    type: "text",
                                                    isIcon: false,
                                                    inputClass:
                                                      "fullwidthInput",
                                                    disabled:
                                                      _vm.isEdittingLocked,
                                                  },
                                                  model: {
                                                    value: _vm.profilelinkp,
                                                    callback: function ($$v) {
                                                      _vm.profilelinkp = $$v
                                                    },
                                                    expression: "profilelinkp",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "row-span-full mt-2" },
                                          [
                                            _c("p", { staticClass: "mb-2" }, [
                                              _vm._v("Duration"),
                                            ]),
                                            _c(
                                              "div",
                                              { staticClass: "flex w-full" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "w-1/2 flex flex-row justify-center",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mt-2 mr-2",
                                                      },
                                                      [_vm._v("From")]
                                                    ),
                                                    _c("ValidationProvider", {
                                                      attrs: {
                                                        rules: "required_field",
                                                        vid: "start_date",
                                                        name: "Start date",
                                                        immediate:
                                                          !!_vm.projectActivity,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function ({
                                                              errors,
                                                              failed,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "FormGroup",
                                                                  {
                                                                    attrs: {
                                                                      errors:
                                                                        errors,
                                                                      name: "start_date",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "FormDatepicker",
                                                                      {
                                                                        attrs: {
                                                                          heightClass:
                                                                            "datePickerHeight",
                                                                          calendarClass:
                                                                            "bottom-11",
                                                                          invalid:
                                                                            failed,
                                                                          disabled:
                                                                            _vm.isEdittingLocked,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.fromdatep,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.fromdatep =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "fromdatep",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "w-1/2 flex flex-row justify-center",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mt-2 mr-2 ml-2",
                                                      },
                                                      [_vm._v("Till")]
                                                    ),
                                                    _c("ValidationProvider", {
                                                      attrs: {
                                                        rules:
                                                          "noBeforeDate:@start_date,@ongoing|required_field",
                                                        vid: "end_date",
                                                        name: "End Date",
                                                        immediate:
                                                          !!_vm.projectActivity,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function ({
                                                              errors,
                                                              failed,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "FormGroup",
                                                                  {
                                                                    attrs: {
                                                                      errors:
                                                                        errors,
                                                                      name: "end_date",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "FormDatepicker",
                                                                      {
                                                                        attrs: {
                                                                          heightClass:
                                                                            "datePickerHeight",
                                                                          calendarClass:
                                                                            "right-0 bottom-11",
                                                                          invalid:
                                                                            failed,
                                                                          disabled:
                                                                            _vm.isEdittingLocked,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.todatep,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.todatep =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "todatep",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row-span-full mt-6 flex",
                                          },
                                          [
                                            _c(
                                              "div",
                                              [
                                                _c("Checkbox", {
                                                  attrs: {
                                                    id: _vm
                                                      .showAvailabilityCheckbox
                                                      .id,
                                                    name: _vm
                                                      .showAvailabilityCheckbox
                                                      .name,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm
                                                        .showAvailabilityCheckbox
                                                        .selected,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.showAvailabilityCheckbox,
                                                        "selected",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "showAvailabilityCheckbox.selected",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "row-span-full" },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                name: "title",
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({
                                                      errors,
                                                      failed,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "FormGroup",
                                                          {
                                                            attrs: {
                                                              id: "title",
                                                              title: "Rate",
                                                              name: "type",
                                                              inputClass:
                                                                "fullwidthInput",
                                                              placeholder:
                                                                "Contractor's rate",
                                                              disabled:
                                                                _vm.isEdittingLocked,
                                                              errors: errors,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "FormInputGroup",
                                                              {
                                                                attrs: {
                                                                  height:
                                                                    "true",
                                                                  inputClass:
                                                                    "fullwidthInput",
                                                                  invalid:
                                                                    failed,
                                                                  inputClasses:
                                                                    "pl-8",
                                                                  type: "number",
                                                                  prefix: "$",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.ratesp,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.ratesp =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "ratesp",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "mt-3" },
                                          [
                                            _c(
                                              "FormGroup",
                                              { attrs: { title: "Notes" } },
                                              [
                                                _c("FormTextarea", {
                                                  attrs: {
                                                    rows: 3,
                                                    customBorderClass:
                                                      "borderTen",
                                                    placeholder:
                                                      "Additional details",
                                                    disabled:
                                                      _vm.isEdittingLocked,
                                                  },
                                                  model: {
                                                    value: _vm.notesp,
                                                    callback: function ($$v) {
                                                      _vm.notesp = $$v
                                                    },
                                                    expression: "notesp",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }